module.exports = __webpack_public_path__ + "static/media/oliver15.336d9422.png";